export type EventHandler<T = unknown> = (payload: T) => void;

export class EventHub {
  private handlers = new Map<string, Set<EventHandler>>();

  public on<T = unknown>(event: string, handler: EventHandler<T>): void {
    const bucket = this.handlers.get(event) ?? new Set();
    bucket.add(handler as EventHandler);
    this.handlers.set(event, bucket);
  }

  public off<T = unknown>(event: string, handler: EventHandler<T>): void {
    const bucket = this.handlers.get(event);
    if (!bucket) {
      return;
    }
    bucket.delete(handler as EventHandler);
    if (bucket.size === 0) {
      this.handlers.delete(event);
    }
  }

  public emit<T = unknown>(event: string, payload?: T): void {
    const bucket = this.handlers.get(event);
    if (!bucket) {
      return;
    }
    for (const handler of bucket) {
      handler(payload);
    }
  }

  public clear(): void {
    this.handlers.clear();
  }
}
